
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { ServiceContext } from "@/script/core/base/ServiceData";
import { ElLoading, ElMessage, ElNotification } from "element-plus";
import {
  createCruiseContext,
  createNodeContext,
} from "@/script/apps/recon/config/ReconConfig";
import {
  Cruise,
  Node,
  NodeCameraGroup,
} from "@/script/apps/recon/entity/ReconEntity";
import {
  Camera,
  Client,
  Server,
} from "@/script/apps/device/entity/DeviceEntity";
import {
  createCameraContext,
  createClientContext,
  createServerContext,
} from "@/script/apps/device/config/DeviceConfig";
import { QueryParam } from "@/script/core/service/DataService";
import { NodeService } from "@/script/apps/recon/service/NodeService";
import { DictUtil } from "@/script/core/Dict";

@Options({})
export default class NodeDetail extends BaseDetail {
  centreServers?: Server[] = [];
  fileServers?: Server[] = [];
  cruiseServers?: Server[] = [];
  algorithmServers?: Server[] = [];
  remoteCameras?: Camera[] = [];
  linkageCameras?: Camera[] = [];
  singleClients?: Client[] = [];
  centreClients?: Client[] = [];
  cruiseList?: Cruise[] = [];

  nodeCameraGroups: NodeCameraGroup[] = [];
  defaultProps = {
    children: "cameras",
    label: "name",
  };

  public initData(): ServiceContext {
    return createNodeContext();
  }

  public newEntity() {
    const entity: Node = {};
    return entity;
  }

  protected initOptions() {
    super.initOptions();
    createServerContext().service.loadFullList((data: Server[]) => {
      this.centreServers = data;
      this.fileServers = data;
      this.cruiseServers = data;
      this.algorithmServers = data;
    });

    createCameraContext().service.loadFullList((data: Camera[]) => {
      this.remoteCameras = data;
      this.linkageCameras = data;
    });

    createClientContext().service.loadFullList((data: Client[]) => {
      this.singleClients = data;
      this.centreClients = data;
    });
  }

  public afterLoad(data: any) {
    const node = this.entity as Node;
    node.nodeDeleteDetails = [];
    this.generateListRowNo(node.nodeDetails!);

    (this.serviceContext.service as NodeService)
      .loadCameraTree(node.id!)
      .then((result: any) => {
        this.nodeCameraGroups = result.data as NodeCameraGroup[];
      });

    this.loadCruises();
  }

  private loadCruises() {
    const node = this.entity as Node;
    (this.serviceContext.service as NodeService)
      .loadCruisesByNode(node.id!)
      .then((result: any) => {
        this.cruiseList = result.data as Cruise[];
        this.cruiseList.forEach((item) => {
          item.typeName = DictUtil.getItemValue("rec-cruise-type", item.type);
          item.stateName = DictUtil.getItemValue(
            "rec-cruise-state",
            item.state!
          );
        });
        this.generateListRowNo(this.cruiseList);
      });
  }

  public cruiseStart() {
    const loading = ElLoading.service({
      lock: true,
      text: "巡航启动中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    const node = this.entity as Node;
    (this.serviceContext.service as NodeService)
      .cruiseStart(node.id!)
      .then((response) => {
        loading.close();
        ElMessage.success("启动成功！");
        this.loadCruises();
      })
      .catch((error) => {
        loading.close();
        ElMessage.error(error.message);
      });
  }

  public cruiseStop() {
    const loading = ElLoading.service({
      lock: true,
      text: "巡航停止中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    const node = this.entity as Node;
    (this.serviceContext.service as NodeService)
      .cruiseStop(node.id!)
      .then((response) => {
        loading.close();
        ElMessage.success("停止成功！");
        this.loadCruises();
      })
      .catch((error) => {
        loading.close();
        ElMessage.error(error.message);
      });
  }

  public cruisePause() {
    const loading = ElLoading.service({
      lock: true,
      text: "巡航暂停中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    const node = this.entity as Node;
    (this.serviceContext.service as NodeService)
      .cruisePause(node.id!)
      .then((response) => {
        loading.close();
        ElMessage.success("巡航暂停成功！");
        this.loadCruises();
      })
      .catch((error) => {
        loading.close();
        ElMessage.error(error.message);
      });
  }

  public cruiseContinue() {
    const loading = ElLoading.service({
      lock: true,
      text: "巡航继续运行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    const node = this.entity as Node;
    (this.serviceContext.service as NodeService)
      .cruiseContinue(node.id!)
      .then((response) => {
        loading.close();
        ElMessage.success("继续运行成功！");
        this.loadCruises();
      })
      .catch((error) => {
        loading.close();
        ElMessage.error(error.message);
      });
  }
}
